import { IPaymentData } from '../../../types/Payment';
import { DisableReason, PaymentMethodStatus } from '../../../consts';

const checkIfSelectedMethodIsDisabledAndFindReason = (paymentData: IPaymentData) => {
  if (paymentData.payment.status !== 'NEW') {
    return [false, undefined];
  }

  let isSelectedPaymentMethodDisabled = false;
  let selectedPaymentMethodDisableReason;
  const chosenPaymentMethodCategory = paymentData.paymentMethodTypes.find(
    pm => pm.type === paymentData.payment.selectedPaymentMethodType
  );

  if (chosenPaymentMethodCategory) {
    isSelectedPaymentMethodDisabled = chosenPaymentMethodCategory.paymentMethods
      .filter(pm => pm.id === paymentData.payment.selectedPaymentMethodId)
      .every(pm => PaymentMethodStatus.DISABLED === pm.status);

    selectedPaymentMethodDisableReason =
      chosenPaymentMethodCategory.paymentMethods.find(pm => pm.id === paymentData.payment.selectedPaymentMethodId)
        ?.disableReason || DisableReason.METHOD_DISABLED;
  }

  return [isSelectedPaymentMethodDisabled, selectedPaymentMethodDisableReason];
};

export default checkIfSelectedMethodIsDisabledAndFindReason;
